/**
 * Theme utility — applies user theme preference to the document
 * S1.10.7: Theme Preference as User Setting
 */

export type ThemePreference = 'light' | 'dark' | 'system'

/**
 * Apply theme preference to the document root element
 * Also persists to localStorage for instant application on next page load
 */
export function applyTheme(theme: ThemePreference): void {
  const isDark =
    theme === 'dark' ||
    (theme === 'system' && globalThis.matchMedia('(prefers-color-scheme: dark)').matches)

  document.documentElement.classList.toggle('dark', isDark);

  localStorage.setItem('theme', theme)
}

/**
 * Initialize theme on app startup (before React renders)
 * Reads from localStorage for instant application, defaults to dark
 */
export function initializeTheme(): void {
  const stored = localStorage.getItem('theme') as ThemePreference | null
  applyTheme(stored || 'dark')
}
